/* JCKED motion: one shared IntersectionObserver reveals content as it scrolls into view.
   - Only opacity/transform are animated (compositor-friendly, no layout work).
   - Anything already visible at load is left alone, so the first paint (and LCP) is never delayed.
   - Skipped entirely for prefers-reduced-motion, the theme editor, and printing.
   - Fail-safe: whatever is still hidden after 5s is shown, so content can never get stuck invisible. */
(function () {
  if (window.__jxMotion) return;
  window.__jxMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  if (reduce || editor || !('IntersectionObserver' in window)) return;

  // Selectors that get the reveal (never the buy box, header, drawer or hero, which must appear instantly).
  var SELECTORS = [
    'main .jx-section .jx-eyebrow', 'main .jx-section .jx-h2', 'main .jx-section .jx-lede',
    'main .jx-card', 'main .jx-vcard', 'main .jx-pick__card', 'main .jx-tl__step', 'main .jx-offer', 'main .jx-chart',
    'main .jx-ing__card', 'main .jx-cmp__table tr', 'main .jx-cards__item', 'main .jx-story__media', 'main .jx-story__copy',
    'main .jx-ql__link', 'main .jx-rev__item', 'main .jx-faq__item', 'main .jx-stats__item', 'main .jx-pcard', 'main .jx-ccard', 'main .jx-rcard'
  ].join(',');

  var pending = [];
  var io = new IntersectionObserver(function (entries) {
    var batch = entries.filter(function (e) { return e.isIntersecting; });
    batch.forEach(function (entry, i) {
      var el = entry.target;
      io.unobserve(el);
      el.style.setProperty('--jx-d', Math.min(i, 5) * 70 + 'ms'); // stagger, capped so long lists never lag
      el.classList.add('jx-in');
      var done = function () { el.classList.remove('jx-rv', 'jx-in'); el.style.removeProperty('--jx-d'); };
      el.addEventListener('transitionend', done, { once: true });
      window.setTimeout(done, 1200); // in case transitionend never fires
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function reveal(el) { io.unobserve(el); el.classList.add('jx-in'); el.classList.remove('jx-rv'); }
  function revealAll() { [].slice.call(document.querySelectorAll('.jx-rv')).forEach(reveal); }

  function init() {
    var vh = window.innerHeight || 800;
    // Read every position first, then write classes: interleaving the two forced a layout per element.
    var below = [].slice.call(document.querySelectorAll(SELECTORS)).filter(function (el) {
      return el.getBoundingClientRect().top >= vh * 0.98; // already on screen: leave visible
    });
    below.forEach(function (el) {
      el.classList.add('jx-rv');
      pending.push(el);
      io.observe(el);
    });
    document.documentElement.classList.add('jx-motion');
    window.setTimeout(revealAll, 5000);
  }

  window.addEventListener('beforeprint', revealAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
